import React from "react";
import { Container, Grid, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import StayInformed from "../utils/StayInformed";
import CopyRight from "../utils/CopyRight";
import { WatchLater } from "@mui/icons-material";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";

export default function Footer() {
  return (
    <div className="footer">
      {/* <StayInformed /> */}
      <Paper elevation={0} className="footer-start">
        <Container maxWidth="lg">
          <Grid container spacing={4} className="space-top">
            <Grid item xs={12} md={6} lg={4}>
              <img src="/images/whitelogo.png" alt="footer_image" />
              <Typography variant="body2" className="description" gutterBottom>
                {/* A lectus ac pulvinar tincidunt accumsan ulla corper dolor at
                lectus ac sed facilis isaclect Molestieuam ublandit nibh
                vulputatctus in sit egestas in dolor purus tincidunt. */}
                RxPose is a non-profit initiative dedicated to making U.S.
                prescription drug price information more transparent and
                accessible to the public.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4} className="office">
              <Typography
                variant="h6"
                className="footer_title heading_four"
                gutterBottom
              >
                Our Main Office
              </Typography>
              <nav>
                <p className="footer-description">
                  <span>
                    <svg width="21" height="16" viewBox="0 0 21 16" fill="none">
                      <path
                        d="M19.8125 3.71875C20.8438 5.40625 19.9062 7.71875 17.9688 7.96875C17.8125 8 17.6875 8 17.5312 8C16.5938 8 15.7812 7.59375 15.2188 6.96875C14.6562 7.59375 13.8438 8 12.9062 8C12 8 11.1562 7.59375 10.5938 6.96875C10.0312 7.59375 9.21875 8 8.3125 8C7.375 8 6.5625 7.59375 6 6.96875C5.4375 7.59375 4.625 8 3.6875 8C3.53125 8 3.40625 8 3.25 7.96875C1.3125 7.71875 0.375 5.40625 1.4375 3.71875L3.4375 0.46875C3.625 0.1875 3.96875 0 4.3125 0H16.9375C17.2812 0 17.5938 0.1875 17.7812 0.46875L19.8125 3.71875ZM17.5312 9C17.7188 9 17.9062 9 18.0938 8.96875C18.2812 8.96875 18.4375 8.90625 18.625 8.875V15C18.625 15.5625 18.1562 16 17.625 16H3.625C3.0625 16 2.625 15.5625 2.625 15V8.875C2.78125 8.90625 2.9375 8.9375 3.125 8.96875C3.3125 9 3.5 9 3.6875 9C4 9 4.3125 8.96875 4.625 8.90625V12H16.625V8.90625C16.9062 8.96875 17.2188 9 17.5312 9Z"
                        fill="#82929B"
                      />
                    </svg>
                  </span>{" "}
                  4200 Hamill Avenue, San Diego, California 92109
                </p>
                <p className="footer-description">
                  <span>
                    <WatchLater />
                  </span>{" "}
                  Monday 07.00 am - 12.00 pm Sunday
                </p>
                <p className="footer-description">
                  <span>
                    <HeadsetMicIcon />
                  </span>{" "}
                  021 0002 345
                </p>
                <p className="footer-description">
                  <span>
                    <LocalPostOfficeIcon />
                  </span>
                  customer@rxpose.com
                </p>
              </nav>
            </Grid>
            <Grid item xs={6} md={6} lg={2}>
              <div className="footer_menu">
                <Typography
                  variant="h6"
                  className="footer_title heading_four"
                  gutterBottom
                >
                  Menu
                </Typography>
                <nav className="footer_nav_link">
                  <Link to="/" gutterBottom>Home</Link>
                  <Link to="/medicines" gutterBottom>Browse Medications</Link>
                  <Link to="/contact-congressman" gutterBottom>Contact Congressman</Link>
                  <Link to="/healthcare" gutterBottom>Healthcare in America</Link>
                  <Link to="/contact" gutterBottom>Contact</Link>
                </nav>
              </div>
            </Grid>
            <Grid item xs={6} md={6} lg={2}>
              <div className="footer_menu">
                <Typography
                  variant="h6"
                  className="footer_title heading_four"
                  gutterBottom
                >
                  Category
                </Typography>
                <nav className="footer_nav_link">
                  <Link to="/medicines">Acid Reflux</Link>
                  <Link to="/medicines">Diabetes</Link>
                  <Link to="/medicines">Heart Health</Link>
                  <Link to="/medicines">Mental Health</Link>
                  <Link to="/medicines">Cancer</Link>
                  <Link to="/medicines">High Cholesterol</Link>
                </nav>
              </div>
            </Grid>
          </Grid>
        </Container>
        <CopyRight />
      </Paper>
    </div>
  );
}
